<script lang="ts">
  import type { NostrEvent } from "@nostr/tools/pure";
  import { pool } from "@nostr/gadgets/global";
  import "nostr-web-components/nostr-name";
  import "nostr-web-components/nostr-text";

  import Link from "./components/Link.svelte";
  import { formatDate, getTitle } from "./utils";
  import { relay, addToKnownUsers } from "./relay.svelte";
  import { write } from "./components/WriteArea.svelte";
  import type { RouteResult } from "@mateothegreat/svelte5-router";

  let { route }: { route: RouteResult } = $props();
  const id = (route.result.path.params as any).id;

  let topic = $state<NostrEvent>();
  $effect(() => {
    pool.get([relay], { ids: [id] }, { label: "topicroot" }).then((evt) => {
      if (evt) {
        addToKnownUsers(evt.pubkey);
        topic = evt;
      }
    });
  });

  let replies = $state<NostrEvent[]>([]);
  $effect(() => {
    let eosed = false;
    let events: NostrEvent[] = [];

    const subcloser = pool.subscribe(
      [relay],
      { kinds: [1111], "#E": [id] },
      {
        label: "replies",
        onevent(evt) {
          addToKnownUsers(evt.pubkey);

          if (eosed) {
            replies.push(evt);
          } else {
            events.push(evt);
          }
        },
        oneose() {
          eosed = true;
          events.reverse();
          replies = events;
          events = [];
        }
      }
    );

    return subcloser.close;
  });
</script>

{#if !topic}
  <div>loading</div>
{:else}
  <div class="mx-auto max-w-4xl px-4 py-8">
    <header class="mb-8">
      <nav class="mb-8">
        <Link
          target="/"
          class="text-sm text-gray-600 hover:text-black dark:text-gray-400 dark:hover:text-white"
          >← Back to Topics</Link
        >
      </nav>
      <h1 class="mb-4 text-3xl font-bold">
        {getTitle(topic)}
      </h1>
      <div
        class="flex items-center gap-4 text-sm text-gray-600 dark:text-gray-400"
      >
        <a
          href="https://njump.me/p/{topic.pubkey}"
          target="_blank"
          aria-label="external link to see author's profile"
          ><nostr-name pubkey={topic.pubkey}>{topic.pubkey}</nostr-name></a
        >
        <time>{formatDate(topic.created_at)}</time>
        <span class="text-gray-400">·</span>
        <span>{replies.length} replies</span>
      </div>
    </header>

    <main>
      <article class="prose prose-slate dark:prose-invert max-w-none">
        <div
          class="rounded-lg border border-gray-200 bg-white p-6 dark:border-gray-700 dark:bg-gray-800"
        >
          <nostr-text content={topic.content}></nostr-text>
        </div>

        <div class="mt-8">
          <h3 class="mb-4 text-lg font-semibold">Replies</h3>
          <div class="space-y-6">
            {#each replies as reply}
              <div
                class="rounded-lg border border-gray-200 bg-white p-6 dark:border-gray-700 dark:bg-gray-800"
                id={reply.id}
              >
                <div class="mb-4 flex items-center justify-between">
                  <div class="flex items-center gap-4">
                    <a
                      href="https://njump.me/p/{reply.pubkey}"
                      target="_blank"
                      aria-label="external link to see author's profile"
                      ><nostr-name pubkey={reply.pubkey}
                        >{reply.pubkey}</nostr-name
                      ></a
                    >
                    <time class="text-sm text-gray-600 dark:text-gray-400"
                      >{formatDate(reply.created_at)}</time
                    >
                  </div>
                  <div class="flex items-center gap-2">
                    <button
                      class="cursor-pointer text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200"
                      onclick={() => write(topic, reply)}>Reply</button
                    >
                  </div>
                </div>
                <p class="text-gray-800 dark:text-gray-200">
                  <nostr-text content={reply.content}></nostr-text>
                </p>
              </div>
            {/each}
          </div>
          <div class="my-6 flex justify-end">
            <button
              class="cursor-pointer rounded bg-gray-800 px-4 py-2 text-sm text-white hover:bg-gray-700 dark:bg-gray-700 dark:hover:bg-gray-600"
              onclick={() => write(topic)}
            >
              Reply
            </button>
          </div>
        </div>
      </article>
    </main>
  </div>
{/if}
